import { render } from "./TaskEditorCmp.vue?vue&type=template&id=a0aded56"
import script from "./TaskEditorCmp.vue?vue&type=script&lang=js"
export * from "./TaskEditorCmp.vue?vue&type=script&lang=js"

import "./TaskEditorCmp.vue?vue&type=style&index=0&id=a0aded56&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__